import React, { useState, useEffect } from "react";
import { Button } from "reactstrap";
import { RatingCounter } from "./RatingCounter";
import "./practiceFooter.scss";

function PracticeFooter(props) {
  const { onClickContinue, glicko, prevGlicko } = props;
  const [thumbs, setThumbs] = useState(null);

  useEffect(() => {
    if (props.exerciseId && thumbs) {
      window.analytics.track("exercise.feedback", {
        id: props.exerciseId,
        direction: thumbs
      });
    }
  }, [thumbs, props.exerciseId]);

  return (
    <div className="practice-footer">
      <div className="practice-footer-content">
        <div className="question-feedback-container">
          <div className="question-feedback-element">
            <div className="question-feedback-label">Your rating</div>
            <RatingCounter glicko={glicko} prevGlicko={prevGlicko} />
          </div>
          <div className="question-feedback-element">
            <div className="question-feedback-label">More like this?</div>
            <div className="like-dislike-container">
              <button
                onClick={() => setThumbs("up")}
                className={`btn-icon btn-question-feedback ${
                  thumbs === "up" ? "btn-question-feedback-up" : ""
                }`}
              >
                <img alt="Thumbs Up" src="/img/icons/thumbs-up.svg" />
              </button>
              <button
                onClick={() => setThumbs("down")}
                className={`btn-icon btn-question-feedback ${
                  thumbs === "down" ? "btn-question-feedback-down" : ""
                }`}
              >
                <img alt="Thumbs Down" src="/img/icons/thumbs-down.svg" />
              </button>
            </div>
          </div>
        </div>
        <Button
          className="btn-continue"
          color="primary"
          onClick={onClickContinue}
        >
          Continue
        </Button>
      </div>
    </div>
  );
}

export { PracticeFooter };
